<template>
  <div class="scroll-page">
    <div class="slick left" @click="goLeft" v-show="info.festivalScroll.left">
      <slot name="left">
        <left-outlined/>
      </slot>
    </div>
    <div class="slick right" @click="goRight" v-show="info.festivalScroll.right">
      <slot name="right">
        <right-outlined/>
      </slot>
    </div>

    <div class="scroll-content" ref="scrollContent" @scroll="onScroll">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, onUnmounted, onUpdated, reactive, ref} from "vue";
import {LeftOutlined, RightOutlined} from "@ant-design/icons-vue";
import emit from "@/lib/emit";

const scrollContent = ref()
const info = reactive({
  filter: {sort: {value: '推荐排序', items: ['推荐排序', '最新上架', '使用最多']}},
  festivalScroll: {offset: 0, left: false, right: true}
})

onMounted(() => {
  scrollButtonRefresh(scrollContent.value as HTMLDivElement)
  emit.on('window.resize', () => scrollButtonRefresh(scrollContent.value as HTMLDivElement))
})
onUnmounted(() => emit.off('window.resize'))
onUpdated(() => scrollButtonRefresh(scrollContent.value as HTMLDivElement))

const onScroll = (e: Event) => scrollButtonRefresh(e.target as HTMLDivElement)

const scrollButtonRefresh = (el: HTMLDivElement) => {
  // console.log(el.scrollWidth, el.clientWidth, el.offsetWidth, el.scrollLeft)
  if (el.scrollWidth - el.clientWidth == 0) {
    // 一样宽，没有超出，不需要滚动
    info.festivalScroll.left = false
    info.festivalScroll.right = false
  } else if (el.scrollLeft == 0) {
    // 左边为0，只需要右侧滚动
    info.festivalScroll.left = false
    info.festivalScroll.right = true
  } else if (el.scrollWidth - el.clientWidth == el.scrollLeft) {
    // 右侧为0，只需要左侧滚动
    info.festivalScroll.left = true
    info.festivalScroll.right = false
  } else {
    // 否则，需要两侧滚动
    info.festivalScroll.left = true
    info.festivalScroll.right = true
  }
}

const goLeft = () => {
  let el = scrollContent.value as HTMLDivElement
  // console.log('goLeft 左侧剩余：', el.scrollLeft, '总宽度：', el.scrollWidth, '窗口宽度：', el.clientWidth)
  // 左侧剩余 > 窗口宽度
  if (el.scrollLeft > el.clientWidth) el.scrollTo({left: el.scrollLeft - el.clientWidth, behavior: 'smooth'})
  else el.scrollTo({left: 0, behavior: 'smooth'})
}

const goRight = () => {
  let el = scrollContent.value as HTMLDivElement

  // console.log('goRight 滚动偏移：', el.scrollLeft, '右侧剩余：', el.scrollWidth - el.clientWidth - el.scrollLeft, '总宽度：', el.scrollWidth, '窗口宽度：', el.clientWidth, (el.scrollWidth - el.clientWidth - el.scrollLeft) < el.clientWidth)
  // 右侧剩余 < 窗口宽度 直接滚动到底
  if ((el.scrollWidth - el.clientWidth - el.scrollLeft) > el.clientWidth)
    el.scrollTo({left: el.scrollLeft + el.clientWidth, behavior: 'smooth'})
  else el.scrollTo({left: el.scrollWidth - el.clientWidth, behavior: 'smooth'})
}
</script>

<style scoped lang="sass">

.scroll-page
  flex: 1
  position: relative
  width: 100%
  overflow: hidden

  > .slick
    display: inline-block
    position: absolute
    top: 50%
    margin-top: -19px

    &.left
      left: 6px
      z-index: 88

    &.right
      right: 6px
      z-index: 88

  .anticon
    background-color: white
    width: 38px
    height: 38px
    font-size: 20px
    border-radius: 30px
    box-shadow: 2px 2px 7px 0 #bfbfbf
    display: inline-block
    line-height: 44px
    cursor: pointer


  > .scroll-content
    overflow: hidden

</style>